import {BrowserModule} from '@angular/platform-browser';
import {APP_INITIALIZER, NgModule} from '@angular/core';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {TopBarComponent} from './components/topbar/topbar.component';
import {MenuComponent} from './components/menu/menu.component';
import {FooterComponent} from './components/footer/footer.component';
import {DevicesComponent} from './components/devices/devices.component';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ButtonModule} from 'primeng/button';
import {ConfirmationService, MessageService, SharedModule} from 'primeng/api';
import {PanelModule} from 'primeng/panel';
import {CheckboxModule} from 'primeng/checkbox';
import {PaginatorModule} from 'primeng/paginator';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {RippleModule} from 'primeng/ripple';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {MenuModule} from 'primeng/menu';
import {DeviceCategoriesComponent} from './components/device-categories/device-categories.component';
import {TableModule} from 'primeng/table';
import {OrganizationsComponent} from './components/organizations/organizations.component';
import {DecodersComponent} from './components/decoders/decoders.component';
import {SidebarModule} from 'primeng/sidebar';
import {InputTextModule} from 'primeng/inputtext';
import {RadioButtonModule} from 'primeng/radiobutton';
import {InputTextareaModule} from 'primeng/inputtextarea';
import {DropdownModule} from 'primeng/dropdown';
import {TriStateCheckboxModule} from 'primeng/tristatecheckbox';
import {MultiSelectModule} from 'primeng/multiselect';
import {DevicesDetailsComponent} from './components/devices/devices-details/devices-details.component';
import {DeviceOverviewComponent} from './components/devices/devices-details/device-overview/device-overview.component';
import {TabMenuModule} from 'primeng/tabmenu';
import {CardModule} from 'primeng/card';
import {DeviceSensorsComponent} from './components/devices/devices-details/device-sensors/device-sensors.component';
import {AssetsComponent} from './components/assets/assets.component';
import {ToastModule} from 'primeng/toast';
import {MessagesModule} from 'primeng/messages';
import {MessageModule} from 'primeng/message';
import {SkeletonModule} from 'primeng/skeleton';
import {BadgeModule} from 'primeng/badge';
import {
  DeviceIntegrationModulesComponent
} from './components/devices/devices-details/device-integration-modules/device-integration-modules.component';
import {DataViewModule} from 'primeng/dataview';
import {DeviceMeasuresComponent} from './components/devices/devices-details/device-measures/device-measures.component';
import {CalendarModule} from 'primeng/calendar';
import {ConfirmPopupModule} from 'primeng/confirmpopup';
import {TenantsComponent} from './components/tenants/tenants.component';
import {AssetsDetailsComponent} from './components/assets/assets-details/assets-details.component';
import {AssetOverviewComponent} from './components/assets/assets-details/asset-overview/asset-overview.component';
import {AssetSensorsComponent} from './components/assets/assets-details/asset-sensors/asset-sensors.component';
import {AssetMeasuresComponent} from './components/assets/assets-details/asset-measures/asset-measures.component';
import {DeviceTriggersComponent} from './components/devices/devices-details/device-triggers/device-triggers.component';
import {InputSwitchModule} from 'primeng/inputswitch';
import {AssetTriggersComponent} from './components/assets/assets-details/asset-triggers/asset-triggers.component';
import {
  DeviceTechnicalDetailsComponent
} from './components/devices/devices-details/device-technical-details/device-technical-details.component';
import {NgxJsonViewerModule} from 'ngx-json-viewer';
import {
  AssetTechnicalDetailsComponent
} from './components/assets/assets-details/asset-technical-details/asset-technical-details.component';
import {TenantDetailsComponent} from './components/tenants/tenant-details/tenant-details.component';
import {
  TenantAssetRepresentationsComponent
} from './components/tenants/tenant-details/tenant-asset-representations/tenant-asset-representations.component';
import {
  TenantOrganizationsComponent
} from './components/tenants/tenant-details/tenant-organizations/tenant-organizations.component';
import {TenantDecodersComponent} from './components/tenants/tenant-details/tenant-decoders/tenant-decoders.component';
import {
  TenantDeviceCategoriesComponent
} from './components/tenants/tenant-details/tenant-device-categories/tenant-device-categories.component';
import {
  TenantTriggerRulesComponent
} from './components/tenants/tenant-details/tenant-trigger-rules/tenant-trigger-rules.component';
import {
  TenantMeasurementTypesComponent
} from './components/tenants/tenant-details/tenant-measurement-types/tenant-measurement-types.component';
import {
  TenantPropertyTypesComponent
} from './components/tenants/tenant-details/tenant-property-types/tenant-property-types.component';
import {StepsModule} from 'primeng/steps';
import {DevicesFormComponent} from './components/devices/devices-form/devices-form.component';
import {
  DevicesFormPropertiesComponent
} from './components/devices/devices-form/devices-form-properties/devices-form-properties.component';
import {
  DevicesFormIntegrationModulesComponent
} from './components/devices/devices-form/devices-form-integration-modules/devices-form-integration-modules.component';
import {
  DevicesFormAssetsComponent
} from './components/devices/devices-form/devices-form-assets/devices-form-assets.component';
import {
  DevicesFormInfoComponent
} from './components/devices/devices-form/devices-form-info/devices-form-info.component';
import {
  DevicesFormMeasurementsComponent
} from './components/devices/devices-form/devices-form-measurements/devices-form-measurements.component';
import {TimelineModule} from 'primeng/timeline';
import {LandingComponent} from './components/landing/landing.component';
import {MapComponent} from './components/map/map.component';
import {AssetsFormComponent} from './components/assets/assets-form/assets-form.component';
import {AssetsFormInfoComponent} from './components/assets/assets-form/assets-form-info/assets-form-info.component';
import {
  AssetsFormMeasurementsComponent
} from './components/assets/assets-form/assets-form-measurements/assets-form-measurements.component';
import {
  AssetsFormPropertiesComponent
} from './components/assets/assets-form/assets-form-properties/assets-form-properties.component';
import {AssetDevicesComponent} from './components/assets/assets-details/asset-devices/asset-devices.component';
import {TranslocoRootModule} from './i18n/transloco-root.module';
import {TranslocoModule} from '@ngneat/transloco';
import {ToggleButtonModule} from 'primeng/togglebutton';
import {TagModule} from 'primeng/tag';
import {TriggersComponent} from './components/triggers/triggers.component';
import {TriggerRulesComponent} from './components/trigger-rules/trigger-rules.component';
import {TraceabilityComponent} from './components/traceability/traceability.component';
import {DeviceEventsComponent} from './components/devices/devices-details/device-events/device-events.component';
import {SubscriptionsComponent} from './components/subscriptions/subscriptions.component';
import {AssetEventsComponent} from './components/assets/assets-details/asset-events/asset-events.component';
import {StatisticsComponent} from './components/statistics/statistics.component';
import {TriggersFormComponent} from './components/triggers/triggers-form/triggers-form.component';
import {ToolbarModule} from 'primeng/toolbar';
import {
  DeviceCategoriesFormComponent
} from './components/device-categories/device-categories-form/device-categories-form.component';
import {TenantsFormComponent} from './components/tenants/tenants-form/tenants-form.component';
import {DataflowGraphComponent} from './components/traceability/dataflow-graph/dataflow-graph.component';
import {InputNumberModule} from 'primeng/inputnumber';
import {InputMaskModule} from 'primeng/inputmask';
import {NgxIntlTelInputModule} from 'ngx-intl-tel-input';
import {DecodersFormComponent} from './components/decoders/decoders-form/decoders-form.component';
import {SubscriptionsFormComponent} from './components/subscriptions/subscriptions-form/subscriptions-form.component';
import {NgJsonEditorModule} from 'ang-jsoneditor';
import {SplitterModule} from 'primeng/splitter';
import {CapitalizePipe} from './shared/pipes/capitalize.pipe';
import {TriggerRulesFormComponent} from './components/trigger-rules/trigger-rules-form/trigger-rules-form.component';
import {CepRulesFormComponent} from './components/cep-rules/cep-rules-form/cep-rules-form.component';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {DialogModule} from 'primeng/dialog';
import {ScrollPanelModule} from 'primeng/scrollpanel';
import {OrganizationsFormComponent} from './components/organizations/organizations-form/organizations-form.component';
import {UsersComponent} from './components/users/users.component';
import {UsersFormComponent} from './components/users/users-form/users-form.component';
import {NotFoundComponent} from './components/not-found/not-found.component';
import {CustomDatePipe} from './shared/pipes/custom-date.pipe';
import {AppHttpInterceptor} from './common/http-interceptor/filtered-http';
import {InitialAuthService} from './common/initialauth.service';
import {OAuthModule} from 'angular-oauth2-oidc';
import {MainComponent} from './main.component';
import {OverlayPanelModule} from 'primeng/overlaypanel';
import {PasswordModule} from 'primeng/password';
import {UsersFormInfoComponent} from './components/users/users-form/users-form-info/users-form-info.component';
import {
  UsersFormCredentialsComponent
} from './components/users/users-form/users-form-credentials/users-form-credentials.component';
import {
  UsersFormApplicationsComponent
} from './components/users/users-form/users-form-applications/users-form-applications.component';
import {TreeModule} from 'primeng/tree';
import {ContextMenuModule} from 'primeng/contextmenu';
import {NotAuthorizedComponent} from './components/not-authorized/not-authorized.component';
import {AutofocusDirective} from './common/autofocus.directive';
import {TooltipModule} from 'primeng/tooltip';
import {CarouselModule} from 'primeng/carousel';
import {MapAssetDetailsComponent} from './components/map/map-asset-details/map-asset-details.component';
import {MapClusterDetailsComponent} from './components/map/map-cluster-details/map-cluster-details.component';
import {SelectButtonModule} from 'primeng/selectbutton';
import {DividerModule} from 'primeng/divider';
import {JsonParsePipe} from './shared/pipes/json-parse.pipe';
import {PendingChangesGuard} from './common/can-deactivate/pending-changes-guard.service';
import {BeforeNavigationGuardService} from './common/can-deactivate/before-navigation-guard.service';
import {TenantOverviewComponent} from './components/tenants/tenant-details/tenant-overview/tenant-overview.component';
import {UserHasRolePipe} from './shared/pipes/required-role.pipe';
import {AppConfigPipe} from './shared/pipes/appConfig.pipe';
import {AvatarModule} from 'primeng/avatar';
import {ClipboardModule} from '@angular/cdk/clipboard';
import {
  OrganizationsDetailsComponent
} from './components/organizations/organizations-details/organizations-details.component';
import {
  OrganizationOverviewComponent
} from './components/organizations/organizations-details/organization-overview/organization-overview.component';
import {
  OrganizationDevicesComponent
} from './components/organizations/organizations-details/organization-devices/organization-devices.component';
import {
  OrganizationAssetsComponent
} from './components/organizations/organizations-details/organization-assets/organization-assets.component';
import {MeasurementTypesComponent} from './components/measurement-types/measurement-types.component';
import {
  MeasurementTypesFormComponent
} from './components/measurement-types/measurement-types-form/measurement-types-form.component';
import {GenericGraphComponent} from './components/shared/generic-graph/generic-graph.component';
import {ByteInputComponent} from './components/shared/byte-input/byte-input.component';
import {ClipboardLabelComponent} from './components/shared/clipboard-label/clipboard-label.component';
import {DeviceSelectorComponent} from './components/shared/device-selector/device-selector.component';
import {HighchartsChartModule} from 'highcharts-angular';
import {ApplicationsComponent} from './components/applications/applications.component';
import {
  ApplicationsFormComponent
} from './components/applications/external-applications-form/applications-form.component';
import {
  OrganizationApiComponent
} from './components/organizations/organizations-details/organization-api/organization-api.component';
import {TenantApiComponent} from './components/tenants/tenant-details/tenant-api/tenant-api.component';
import {CepRulesComponent} from './components/cep-rules/cep-rules.component';
import {CepRulesDetailsComponent} from './components/cep-rules/cep-rules-details/cep-rules-details.component';
import {ValidationErrorsComponent} from './components/shared/validation-errors/validation-errors.component';
import {AssetSelectorComponent} from './components/shared/asset-selector/asset-selector.component';
import {AssetRepresentationsComponent} from './components/asset-representations/asset-representations.component';
import {
  AssetRepresentationsFormComponent
} from './components/asset-representations/asset-representations-form/asset-representations-form.component';
import {TenantsResolverPipe} from './shared/pipes/tenants-resolver.pipe';
import {OrganizationsResolverPipe} from './shared/pipes/organizations-resolver.pipe';
import {OrderListModule} from 'primeng/orderlist';
import {
  EntitiesMeasurementSelectorComponent
} from './components/cep-rules/cep-rules-form/entities-measurement-selector/entities-measurement-selector.component';
import {KpisComponent} from './components/kpis/kpis.component';
import {KpisFormComponent} from './components/kpis/kpis-form/kpis-form.component';
import {
  DeviceMeasurementsSelectorComponent
} from './components/shared/device-measurements-selector/device-measurements-selector.component';
import {KpisSelectorComponent} from './components/shared/kpis-selector/kpis-selector.component';
import {NettopoMapComponent} from './components/network-topology/nettopo-map.component';
import {ChipsModule} from 'primeng/chips';
import {DeviceNettopoComponent} from './components/devices/devices-details/device-nettopo/device-nettopo.component';
import {TableSkeletonComponent} from './components/shared/table-skeleton/table-skeleton.component';
import {FormatNumberPipe} from './shared/pipes/FormatNumber.pipe';
import {
  DevicesFormExpressionsComponent
} from './components/devices/devices-form/devices-form-expressions/devices-form-expressions.component';
import {
  DevicesStepComponent
} from './components/shared/device-measurements-selector/devices-step/devices-step.component';
import {
  DeviceMeasurementsStepComponent
} from './components/shared/device-measurements-selector/device-measurements-step/device-measurements-step.component';
import {AssetsStepComponent} from './components/shared/asset-measurements-selector/assets-step/assets-step.component';
import {
  AssetMeasurementsStepComponent
} from './components/shared/asset-measurements-selector/asset-measurements-step/asset-measurements-step.component';
import {
  AssetMeasurementsSelectorComponent
} from './components/shared/asset-measurements-selector/asset-measurements-selector.component';
import {KpisDetailsComponent} from './components/kpis/kpis-details/kpis-details.component';
import {KpiOverviewComponent} from './components/kpis/kpis-details/kpi-overview/kpi-overview.component';
import {KpiComponentsComponent} from './components/kpis/kpis-details/kpi-components/kpi-components.component';
import {KpiMeasuresComponent} from './components/kpis/kpis-details/kpi-measures/kpi-measures.component';
import {MapFilterDetailsComponent} from './components/map/map-filter-details/map-filter-details.component';
import {ShareEntityDialogComponent} from './components/shared/share-entity-dialog/share-entity-dialog.component';
import {AutoCompleteModule} from 'primeng/autocomplete';
import {SharedResourcesComponent} from './components/shared-resources/shared-resources.component';
import {
  SharedResourcesDetailsComponent
} from './components/shared-resources/shared-resources-details/shared-resources-details.component';
import {SharedWithMeComponent} from './components/shared-resources/shared-with-me/shared-with-me.component';
import {SharedByUserComponent} from './components/shared-resources/shared-by-user/shared-by-user.component';
import {TemplatesComponent} from './components/templates/templates.component';
import {TemplatesFormComponent} from './components/templates/templates-form/templates-form.component';
import {
  TemplatesFormInfoComponent
} from './components/templates/templates-form/templates-form-info/templates-form-info.component';
import {TemplatesDetailsComponent} from './components/templates/templates-details/templates-details.component';
import {
  TemplateOverviewComponent
} from './components/templates/templates-details/template-overview/template-overview.component';
import {
  TemplateSensorsComponent
} from './components/templates/templates-details/template-sensors/template-sensors.component';
import {
  TemplatePropertiesComponent
} from './components/templates/templates-details/template-properties/template-properties.component';
import {
  TemplatesFormMeasurementsComponent
} from './components/templates/templates-form/templates-form-measurements/templates-form-measurements.component';
import {
  TemplatesFormPropertiesComponent
} from './components/templates/templates-form/templates-form-properties/templates-form-properties.component';
import {TemplateSelectorComponent} from './components/shared/template-selector/template-selector.component';
import {
  TemplateIntegrationModulesComponent
} from './components/templates/templates-details/template-integration-modules/template-integration-modules.component';
import {EncodersComponent} from './components/encoders/encoders.component';
import {EncodersFormComponent} from './components/encoders/encoders-form/encoders-form.component';
import {TabViewModule} from 'primeng/tabview';
import {KpisFormInfoComponent} from './components/kpis/kpis-form/kpis-form-info/kpis-form-info.component';
import {
  KpisFormMeasurementsComponent
} from './components/kpis/kpis-form/kpis-form-measurements/kpis-form-measurements.component';
import {
  KpisFormConfirmationComponent
} from './components/kpis/kpis-form/kpis-form-confirmation/kpis-form-confirmation.component';
import {
  KpisFormFilteredMeasurementsComponent
} from './components/kpis/kpis-form/kpis-form-filtered-measurements/kpis-form-filtered-measurements.component';
import {DevicesCsvComponent} from './components/devices/devices-csv/devices-csv.component';
import {UploadCsvComponent} from './components/shared/upload-csv/upload-csv.component';
import {DragDropDirective} from './shared/drag-drop.directive';
import {AccordionModule} from 'primeng/accordion';
import {CsvHistoryComponent} from './components/csv-history/csv-history.component';
import {ExportXlsComponent} from './components/shared/export-xls/export-xls.component';
import {DragDropModule} from 'primeng/dragdrop';
import {TenantsConfirmationComponent} from './components/shared/tenants-confirmation/tenants-confirmation.component';
import {ImportMeasurementsCsvComponent} from './components/import-measurements-csv/import-measurements-csv.component';
import {DeviceCommandsComponent} from './components/devices/devices-details/device-commands/device-commands.component';
import {IndustrialGatewayV1Module, Zmxconnect0262V1Module} from '@iotsens/commands';
import {
  ZmxCommandsComponent
} from './components/devices/devices-details/device-commands/zmx-commands/zmx-commands.component';
import {HwCatalogComponent} from './components/hw-catalog/hw-catalog.component';
import {
  DefaultDeviceCategoriesComponent
} from './components/hw-catalog/default-device-categories/default-device-categories.component';
import {
  DefaultMeasurementTypesComponent
} from './components/hw-catalog/default-measurement-types/default-measurement-types.component';
import {
  DefaultPropertyTypesComponent
} from './components/hw-catalog/default-property-types/default-property-types.component';
import {
  DefaultAssetRepresentationsComponent
} from './components/hw-catalog/default-asset-representations/default-asset-representations.component';
import {DefaultDecodersComponent} from './components/hw-catalog/default-decoders/default-decoders.component';
import {
  DefaultMeasurementTypesFormComponent
} from './components/hw-catalog/default-measurement-types/default-measurement-types-form/default-measurement-types-form.component';
import {
  DefaultDeviceCategoriesFormComponent
} from './components/hw-catalog/default-device-categories/default-device-categories-form/default-device-categories-form.component';
import {
  DefaultPropertyTypesFormComponent
} from './components/hw-catalog/default-property-types/default-property-types-form/default-property-types-form.component';
import {
  DefaultDecodersFormComponent
} from './components/hw-catalog/default-decoders/default-decoders-form/default-decoders-form.component';
import {
  DefaultAssetRepresentationsFormComponent
} from './components/hw-catalog/default-asset-representations/default-asset-representations-form/default-asset-representations-form.component';
import {DefaultEncodersComponent} from './components/hw-catalog/default-encoders/default-encoders.component';
import {
  DefaultEncodersFormComponent
} from './components/hw-catalog/default-encoders/default-encoders-form/default-encoders-form.component';
import {
  DefaultDeviceSelectorComponent
} from './components/shared/default-device-selector/default-device-selector.component';
import {
  DefaultDeviceIntegrationModulesComponent
} from './components/hw-catalog/default-devices/default-devices-details/default-device-integration-modules/default-device-integration-modules.component';
import {
  DefaultDevicesFormMeasurementsComponent
} from './components/hw-catalog/default-devices/default-devices-form/default-devices-form-measurements/default-devices-form-measurements.component';
import {
  DefaultDeviceSensorsComponent
} from './components/hw-catalog/default-devices/default-devices-details/default-device-sensors/default-device-sensors.component';
import {
  DefaultDevicesFormIntegrationModulesComponent
} from './components/hw-catalog/default-devices/default-devices-form/default-devices-form-integration-modules/default-devices-form-integration-modules.component';
import {
  DefaultDevicePropertiesComponent
} from './components/hw-catalog/default-devices/default-devices-details/default-device-properties/default-device-properties.component';
import {
  DefaultDevicesFormPropertiesComponent
} from './components/hw-catalog/default-devices/default-devices-form/default-devices-form-properties/default-devices-form-properties.component';
import {
  DefaultDevicesFormExpressionsComponent
} from './components/hw-catalog/default-devices/default-devices-form/default-devices-form-expressions/default-devices-form-expressions.component';
import {
  DefaultDeviceOverviewComponent
} from './components/hw-catalog/default-devices/default-devices-details/default-device-overview/default-device-overview.component';
import {
  DefaultDevicesFormInfoComponent
} from './components/hw-catalog/default-devices/default-devices-form/default-devices-form-info/default-devices-form-info.component';
import {
  DefaultDevicesDetailsComponent
} from './components/hw-catalog/default-devices/default-devices-details/default-devices-details.component';
import {
  DefaultDevicesFormComponent
} from './components/hw-catalog/default-devices/default-devices-form/default-devices-form.component';
import {DefaultDevicesComponent} from './components/hw-catalog/default-devices/default-devices.component';
import {DevicesRemovedComponent} from './components/devices-removed/devices-removed.component';
import {SynopticsComponent} from './components/synoptics/synoptics.component';
import {SynopticsFormComponent} from './components/synoptics/synoptics-form/synoptics-form.component';
import {
  SynopticsFormInfoComponent
} from './components/synoptics/synoptics-form/synoptics-form-info/synoptics-form-info.component';
import {
  SynopticsFormFilesComponent
} from './components/synoptics/synoptics-form/synoptics-form-files/synoptics-form-files.component';
import {
  SynopticsFormStateDataComponent
} from './components/synoptics/synoptics-form/synoptics-form-state-data/synoptics-form-state-data.component';
import {
  SynopticsFormConfigurationComponent
} from './components/synoptics/synoptics-form/synoptics-form-configuration/synoptics-form-configuration.component';
import {
  SynopticsFormConfirmationComponent
} from './components/synoptics/synoptics-form/synoptics-form-confirmation/synoptics-form-confirmation.component';
import {TranslateLabelsPipe} from './shared/pipes/translate-labels.pipe';
import {
  SynopticVisualizationComponent
} from './components/synoptics/synoptic-details/synoptic-visualization/synoptic-visualization.component';
import {ColorPickerComponent} from './components/shared/color-picker/color-picker.component';
import {
  SynopticsFormStatesComponent
} from './components/synoptics/synoptics-form/synoptics-form-configuration/synoptics-form-states/synoptics-form-states.component';
import {
  SynopticsFormEventsComponent
} from './components/synoptics/synoptics-form/synoptics-form-configuration/synoptics-form-events/synoptics-form-events.component';
import {
  SynopticsFormEventDataComponent
} from './components/synoptics/synoptics-form/synoptics-form-event-data/synoptics-form-event-data.component';
import {GenericCommandInputComponent} from './components/shared/generic-command-input/generic-command-input.component';
import {TrustContentPipe} from './shared/pipes/trust-content.pipe';
import {ArrayFilterPipe} from './shared/pipes/array-filter.pipe';
import {ArrayFindPipe} from './shared/pipes/array-find.pipe';
import {ElementSizePipe} from './shared/pipes/element-size.pipe';
import {SynopticDetailsComponent} from './components/synoptics/synoptic-details/synoptic-details.component';
import {SplitButtonModule} from 'primeng/splitbutton';
import {
  SynopticsFormMeasurementSelectorComponent
} from './components/synoptics/synoptics-form/synoptics-form-configuration/shared/synoptics-form-measurement-selector/synoptics-form-measurement-selector.component';
import {AnchorSelectorComponent} from './components/shared/anchor-selector/anchor-selector.component';
import {SliderModule} from 'primeng/slider';
import {
  SynopticVisualizationCommandParamsComponent
} from './components/synoptics/synoptic-details/synoptic-visualization/synoptic-visualization-command-params/synoptic-visualization-command-params.component';
import {DialogService} from 'primeng/dynamicdialog';
import {AnyNullPipe} from './shared/pipes/any-null.pipe';
import {
  SynopticsFormEventActionComponent
} from './components/synoptics/synoptics-form/synoptics-form-configuration/synoptics-form-events/synoptics-form-event-action/synoptics-form-event-action.component';
import {
  SynopticsFormStaticComponent
} from './components/synoptics/synoptics-form/synoptics-form-configuration/synoptics-form-static/synoptics-form-static.component';
import {
  SynopticsFormStateModifierComponent
} from './components/synoptics/synoptics-form/synoptics-form-configuration/synoptics-form-states/synoptics-form-state-modifier/synoptics-form-state-modifier.component';
import {RouteReuseStrategy} from '@angular/router';
import {CustomRouteReuseStrategy} from './common/http-interceptor/custom-route-reuse-strategy';
import {
  KpiRecalculateMeasuresDialogComponent
} from './components/kpis/kpis-details/kpi-measures/kpi-recalculate-measures-dialog/kpi-recalculate-measures-dialog.component';
import {AuditsComponent} from './components/audits/audits.component';
import {
  DeviceDiagnosisComponent
} from './components/devices/devices-details/device-diagnosis/device-diagnosis.component';
import {InplaceModule} from 'primeng/inplace';
import {ProgressBarModule} from 'primeng/progressbar';
import {NotificationsComponent} from './components/notifications/notifications.component';
import {NotificationsFormComponent} from './components/notifications/notifications-form/notifications-form.component';
import {MustachePipe} from './shared/pipes/mustache.pipe';
import {AngularEditorModule} from '@kolkov/angular-editor';
import {NodeDetailsComponent} from './components/network-topology/node-details/node-details.component';
import {HIGHLIGHT_OPTIONS, HighlightModule} from 'ngx-highlightjs';
import {StyleClassModule} from 'primeng/styleclass';
import {TriggersCsvComponent} from './components/triggers/triggers-csv/triggers-csv.component';
import {SynopticThumbnailComponent} from './components/synoptics/synoptic-thumbnail/synoptic-thumbnail.component';
import {
  SynopticsFormVisualizationComponent
} from './components/synoptics/synoptics-form/synoptics-form-configuration/synoptics-form-visualization/synoptics-form-visualization.component';
import {
  IndustrialGatewayCommandsComponent
} from './components/devices/devices-details/device-commands/industrial-gateway-commands/industrial-gateway-commands.component';
import {
  SynopticsIndustrialGatewayComponent
} from './components/synoptics/synoptic-custom-command-form/synoptic-industrial-gateway/synoptics-industrial-gateway.component';
import {SequenceFormComponent} from './components/sequences/sequences-form/sequence-form.component';
import {SequencesComponent} from './components/sequences/sequences.component';
import {
  SequenceSubscriptionInputComponent
} from './components/sequences/sequences-subscription/sequence-subscription-input.component';
import {
  SequenceFormInfoComponent
} from './components/sequences/sequences-form/sequences-form-info/sequence-form-info.component';
import {
  SequenceFormConfigurationComponent
} from './components/sequences/sequences-form/sequences-form-configuration/sequence-form-configuration.component';
import {FileUploadModule} from 'primeng/fileupload';
import {
  SequenceScheduleCardComponent
} from './components/sequences/sequences-misc/sequences-schedule-card/sequence-schedule-card.component';
import {
  SequenceFormConfigurationErrorsComponent
} from './components/sequences/sequences-form/sequences-form-configuration-errors/sequence-form-configuration-errors.component';

@NgModule({
  declarations: [
    MainComponent,
    AppComponent,
    TopBarComponent,
    MenuComponent,
    FooterComponent,
    DevicesComponent,
    DeviceCategoriesComponent,
    OrganizationsComponent,
    DecodersComponent,
    DevicesDetailsComponent,
    DeviceOverviewComponent,
    DeviceSensorsComponent,
    AssetsComponent,
    DeviceIntegrationModulesComponent,
    DeviceMeasuresComponent,
    TenantsComponent,
    AssetsDetailsComponent,
    AssetOverviewComponent,
    AssetSensorsComponent,
    AssetMeasuresComponent,
    DeviceTriggersComponent,
    AssetTriggersComponent,
    DeviceTechnicalDetailsComponent,
    AssetTechnicalDetailsComponent,
    TenantDetailsComponent,
    TenantAssetRepresentationsComponent,
    TenantOrganizationsComponent,
    TenantDecodersComponent,
    TenantDeviceCategoriesComponent,
    TenantTriggerRulesComponent,
    TenantMeasurementTypesComponent,
    TenantPropertyTypesComponent,
    DevicesFormComponent,
    DevicesFormInfoComponent,
    DevicesFormMeasurementsComponent,
    DevicesFormPropertiesComponent,
    DevicesFormIntegrationModulesComponent,
    DevicesFormAssetsComponent,
    CepRulesDetailsComponent,
    LandingComponent,
    MapComponent,
    AssetsFormComponent,
    AssetsFormInfoComponent,
    AssetsFormMeasurementsComponent,
    AssetsFormPropertiesComponent,
    AssetDevicesComponent,
    TriggersComponent,
    TriggerRulesComponent,
    CepRulesComponent,
    TraceabilityComponent,
    DeviceEventsComponent,
    SubscriptionsComponent,
    NotificationsComponent,
    NotificationsFormComponent,
    SharedResourcesComponent,
    AssetEventsComponent,
    StatisticsComponent,
    TriggersFormComponent,
    DeviceCategoriesFormComponent,
    TenantsFormComponent,
    DecodersFormComponent,
    SubscriptionsFormComponent,
    CapitalizePipe,
    DataflowGraphComponent,
    TriggerRulesFormComponent,
    CepRulesFormComponent,
    OrganizationsFormComponent,
    UsersComponent,
    UsersFormComponent,
    UsersFormInfoComponent,
    UsersFormCredentialsComponent,
    UsersFormApplicationsComponent,
    NotFoundComponent,
    NotAuthorizedComponent,
    CustomDatePipe,
    AutofocusDirective,
    MapAssetDetailsComponent,
    MapClusterDetailsComponent,
    JsonParsePipe,
    UserHasRolePipe,
    TenantOverviewComponent,
    AppConfigPipe,
    OrganizationsDetailsComponent,
    OrganizationOverviewComponent,
    OrganizationDevicesComponent,
    OrganizationAssetsComponent,
    MeasurementTypesComponent,
    MeasurementTypesFormComponent,
    GenericGraphComponent,
    ByteInputComponent,
    ClipboardLabelComponent,
    DeviceSelectorComponent,
    OrganizationApiComponent,
    TenantApiComponent,
    DeviceSelectorComponent,
    OrganizationAssetsComponent,
    ApplicationsComponent,
    ApplicationsFormComponent,
    ValidationErrorsComponent,
    DeviceSelectorComponent,
    AssetSelectorComponent,
    AssetRepresentationsComponent,
    AssetRepresentationsFormComponent,
    NettopoMapComponent,
    TenantsResolverPipe,
    OrganizationsResolverPipe,
    EntitiesMeasurementSelectorComponent,
    KpisComponent,
    KpisFormComponent,
    DeviceMeasurementsSelectorComponent,
    DeviceNettopoComponent,
    DeviceDiagnosisComponent,
    KpisSelectorComponent,
    TableSkeletonComponent,
    FormatNumberPipe,
    DevicesFormExpressionsComponent,
    DevicesStepComponent,
    DeviceMeasurementsStepComponent,
    DeviceMeasurementsSelectorComponent,
    AssetsStepComponent,
    AssetMeasurementsStepComponent,
    AssetMeasurementsSelectorComponent,
    KpisDetailsComponent,
    KpiOverviewComponent,
    KpiComponentsComponent,
    KpiMeasuresComponent,
    MapFilterDetailsComponent,
    ShareEntityDialogComponent,
    SharedResourcesDetailsComponent,
    SharedWithMeComponent,
    SharedByUserComponent,
    TemplatesComponent,
    TemplatesFormComponent,
    TemplatesFormInfoComponent,
    TemplatesDetailsComponent,
    TemplateOverviewComponent,
    TemplateSensorsComponent,
    TemplatePropertiesComponent,
    TemplatesFormMeasurementsComponent,
    TemplatesFormPropertiesComponent,
    TemplateSelectorComponent,
    TemplateIntegrationModulesComponent,
    EncodersComponent,
    EncodersFormComponent,
    KpisFormInfoComponent,
    KpisFormMeasurementsComponent,
    KpisFormConfirmationComponent,
    KpisFormFilteredMeasurementsComponent,
    EncodersFormComponent,
    TemplateIntegrationModulesComponent,
    DevicesCsvComponent,
    ImportMeasurementsCsvComponent,
    UploadCsvComponent,
    DragDropDirective,
    CsvHistoryComponent,
    ExportXlsComponent,
    TenantsConfirmationComponent,
    DeviceCommandsComponent,
    ZmxCommandsComponent,
    HwCatalogComponent,
    DefaultDeviceCategoriesComponent,
    DefaultMeasurementTypesComponent,
    DefaultPropertyTypesComponent,
    DefaultAssetRepresentationsComponent,
    DefaultDecodersComponent,
    DefaultDevicesComponent,
    DefaultMeasurementTypesFormComponent,
    DefaultDeviceCategoriesFormComponent,
    DefaultPropertyTypesFormComponent,
    DefaultDecodersFormComponent,
    DefaultAssetRepresentationsFormComponent,
    DefaultDevicesFormComponent,
    DefaultDevicesDetailsComponent,
    DefaultDevicesFormInfoComponent,
    DefaultDeviceOverviewComponent,
    DefaultEncodersComponent,
    DefaultEncodersFormComponent,
    DefaultDevicesFormMeasurementsComponent,
    DefaultDevicesFormExpressionsComponent,
    DefaultDevicesFormPropertiesComponent,
    DefaultDevicesFormIntegrationModulesComponent,
    DefaultDeviceSensorsComponent,
    DefaultDevicePropertiesComponent,
    DefaultDeviceIntegrationModulesComponent,
    DefaultDeviceSelectorComponent,
    DevicesRemovedComponent,
    ZmxCommandsComponent,
    SynopticsComponent,
    SynopticsFormComponent,
    SynopticsFormInfoComponent,
    SynopticsFormFilesComponent,
    SynopticsFormStateDataComponent,
    SynopticsFormConfigurationComponent,
    SynopticsFormConfirmationComponent,
    TranslateLabelsPipe,
    SynopticVisualizationComponent,
    ColorPickerComponent,
    SynopticsFormStatesComponent,
    SynopticsFormEventsComponent,
    SynopticsFormEventDataComponent,
    GenericCommandInputComponent,
    TrustContentPipe,
    ArrayFilterPipe,
    ArrayFindPipe,
    ElementSizePipe,
    SynopticDetailsComponent,
    SynopticsFormMeasurementSelectorComponent,
    AnchorSelectorComponent,
    SynopticVisualizationCommandParamsComponent,
    AnyNullPipe,
    SynopticsFormEventActionComponent,
    SynopticsFormStaticComponent,
    SynopticsFormStateModifierComponent,
    KpiRecalculateMeasuresDialogComponent,
    AuditsComponent,
    MustachePipe,
    NodeDetailsComponent,
    NodeDetailsComponent,
    TriggersCsvComponent,
    SynopticThumbnailComponent,
    SynopticsFormVisualizationComponent,
    IndustrialGatewayCommandsComponent,
    SynopticsIndustrialGatewayComponent,
    SynopticsFormVisualizationComponent,
    SequenceFormComponent,
    SequencesComponent,
    SequenceSubscriptionInputComponent,
    SequenceFormInfoComponent,
    SequenceFormConfigurationComponent,
    SequenceScheduleCardComponent,
    SequenceFormConfigurationErrorsComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    CheckboxModule,
    PaginatorModule,
    ButtonModule,
    PanelModule,
    TableModule,
    SharedModule,
    RippleModule,
    ProgressSpinnerModule,
    MenuModule,
    SidebarModule,
    InputTextModule,
    RadioButtonModule,
    InputTextareaModule,
    DropdownModule,
    TriStateCheckboxModule,
    MultiSelectModule,
    TabMenuModule,
    CardModule,
    ToastModule,
    MessagesModule,
    MessageModule,
    DialogModule,
    SkeletonModule,
    BadgeModule,
    DataViewModule,
    CalendarModule,
    ConfirmPopupModule,
    InputSwitchModule,
    NgxJsonViewerModule,
    StepsModule,
    ReactiveFormsModule,
    TimelineModule,
    TranslocoRootModule,
    ToggleButtonModule,
    TagModule,
    ToolbarModule,
    InputNumberModule,
    InputMaskModule,
    NgxIntlTelInputModule,
    NgJsonEditorModule,
    SplitterModule,
    ConfirmPopupModule,
    ConfirmDialogModule,
    PasswordModule,
    TreeModule,
    ContextMenuModule,
    DialogModule,
    ChipsModule,
    ScrollPanelModule,
    OverlayPanelModule,
    OrderListModule,
    OAuthModule.forRoot({
      resourceServer: {
        sendAccessToken: true
      }
    }),
    TooltipModule,
    CarouselModule,
    SelectButtonModule,
    DividerModule,
    AvatarModule,
    ClipboardModule,
    HighchartsChartModule,
    AutoCompleteModule,
    AccordionModule,
    TabViewModule,
    DragDropModule,
    Zmxconnect0262V1Module,
    SplitButtonModule,
    SliderModule,
    InplaceModule,
    ProgressBarModule,
    SplitterModule,
    AngularEditorModule,
    HighlightModule,
    StyleClassModule,
    IndustrialGatewayV1Module,
    FileUploadModule
  ],
  exports: [
    TranslocoModule,
    AutofocusDirective
  ],
  providers: [
    {
      provide: HIGHLIGHT_OPTIONS,
      useValue: {
        coreLibraryLoader: () => import('highlight.js/lib/core'),
        lineNumbersLoader: () => import('highlightjs-line-numbers.js'),
        languages: {
          javascript: () => import('highlight.js/lib/languages/javascript'),
        }
      }
    },
    ConfirmationService,
    MessageService,
    DialogService,
    PendingChangesGuard,
    CustomDatePipe,
    BeforeNavigationGuardService,
    {provide: HTTP_INTERCEPTORS, useClass: AppHttpInterceptor, multi: true},
    InitialAuthService,
    {
      provide: APP_INITIALIZER,
      useFactory: (initialAuthService: InitialAuthService) => () => initialAuthService.initAuth(),
      deps: [InitialAuthService],
      multi: true
    },
    {provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy}
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}

